import Vue from 'vue'
import Vuex from 'vuex'
import router from './router'
import './utils/axios'

Vue.use(Vuex)

// const dynamicRoutes = [
//   {
//     path: '/home',
//     meta: {
//       title: '首頁',
//       menuCss: 'active-home',
//       requireAuth: true
//     },
//     component: () => import('./views/template/Layout'),
//     children: [
//       {
//         path: '',
//         name: 'Home',
//         component: () => import('./views/Home')
//       }
//     ]
//   },
//   {
//     path: '/user',
//     meta: {
//       title: '帳號資訊',
//       menuCss: 'active-user',
//       requireAuth: true
//     },
//     component: () => import('./views/template/Layout'),
//     children: [
//       {
//         path: '',
//         name: 'User',
//         component: () => import('./views/user/User'),
//         redirect: { name: 'UserInfo' },
//         children: [
//           {
//             path: 'info',
//             name: 'UserInfo',
//             meta: {
//               subtitle: '個人資訊',
//               tagCss: 'active-tag-user-info'
//             },
//             component: () => import('./views/user/Info')
//           },
//           {
//             path: 'history/watch',
//             name: 'UserHistoryWatch',
//             meta: {
//               subtitle: '觀看記錄',
//               tagCss: 'active-tag-user-watch'
//             },
//             component: () => import('./views/user/HistoryWatch')
//           },
//           {
//             path: 'history/login',
//             name: 'UserHistoryLogin',
//             meta: {
//               subtitle: '登入記錄',
//               tagCss: 'active-tag-user-login'
//             },
//             component: () => import('./views/user/HistoryLogin')
//           }
//         ]
//       }
//
//     ]
//   },
//   {
//     path: '/class',
//     // name: 'Class',
//     meta: {
//       title: '我的課程',
//       menuCss: 'active-class',
//       requireAuth: true
//     },
//     // redirect: { name: 'ClassList' },
//     component: () => import('./views/template/Layout'),
//     children: [
//       {
//         path: '',
//         name: 'Class',
//         meta: {
//           subtitle: '課程清單',
//           routeContentName: 'ClassSubject'
//         },
//         component: () => import('./views/class/Class')
//       },
//       {
//         path: ':class_id(\\d+)',
//         name: 'ClassSubject',
//         meta: {
//           subtitle: '科目清單',
//           routeContentName: 'ClassSubjectVideo'
//         },
//         component: () => import('./views/class/ClassSubject')
//       },
//       {
//         path: ':class_id(\\d+)/:subject_id(\\d+)',
//         name: 'ClassSubjectVideo',
//         meta: {
//           subtitle: '影片清單',
//           routeContentName: 'ClassSubjectVideoContent'
//         },
//         component: () => import('./views/class/ClassSubjectVideo')
//       },
//       {
//         path: ':class_id(\\d+)/:subject_id(\\d+)/:content_id(\\d+)',
//         name: 'ClassSubjectVideoContent',
//         meta: {
//           subtitle: '影片內容'
//         },
//         component: () => import('./views/class/ClassSubjectVideoContent')
//       }
//     ]
//   },
//   {
//     path: '/news',
//     meta: {
//       title: '公告資訊',
//       menuCss: 'active-news',
//       requireAuth: true
//     },
//     component: () => import('./views/template/Layout'),
//     children: [
//       {
//         path: '',
//         name: 'News',
//         redirect: { name: 'NewsSystem' }
//       },
//       {
//         path: 'system',
//         meta: {
//           subtitle: '系統公告',
//           tagCss: 'active-tag-news-system'
//         },
//         component: () => import('./views/news/System'),
//         children: [
//           {
//             path: '',
//             name: 'NewsSystem',
//             meta: {
//               routeContentName: 'NewsSystemContent'
//             },
//             component: () => import('./components/TableList')
//           },
//           {
//             path: 'content/:id',
//             name: 'NewsSystemContent',
//             component: () => import('./components/CkeditContent')
//           }
//         ]
//       },
//       {
//         path: 'user',
//         meta: {
//           subtitle: '學員公告',
//           tagCss: 'active-tag-news-user'
//         },
//         component: () => import('./views/news/User'),
//         children: [
//           {
//             path: '',
//             name: 'NewsUser',
//             meta: {
//               routeContentName: 'NewsUserContent'
//             },
//             component: () => import('./components/TableList')
//           },
//           {
//             path: 'content/:id',
//             name: 'NewsUserContent',
//             component: () => import('./components/CkeditContent')
//           }
//         ]
//       }
//     ]
//   },
//   {
//     path: '/faqs',
//     meta: {
//       title: '常見問題',
//       menuCss: 'active-faqs',
//       routeContentName: 'FaqContent',
//       requireAuth: true
//     },
//     component: () => import('./views/template/Layout'),
//     children: [
//       {
//         path: '',
//         name: 'Faqs',
//         component: () => import('./views/faqs/Faqs')
//       },
//       {
//         path: ':id',
//         name: 'FaqContent',
//         component: () => import('./views/faqs/Faqs')
//       }
//     ]
//   },
//   {
//     path: '/contact',
//     meta: {
//       title: '聯絡我們',
//       menuCss: 'active-contact',
//       requireAuth: true
//     },
//     component: () => import('./views/template/Layout'),
//     children: [
//       {
//         path: '',
//         name: 'Contact',
//         component: () => import('./views/contact/Contact')
//       }
//     ]
//   },
//   {
//     path: '/static',
//     meta: {
//       requireAuth: true
//     },
//     redirect: { name: 'StaticService' },
//     component: () => import('./views/template/Layout'),
//     children: [
//       {
//         path: 'obligations',
//         name: 'StaticObligations',
//         component: () => import('./views/static/StaticObligations')
//       },
//       {
//         path: 'privacy',
//         name: 'StaticPrivacy',
//         component: () => import('./views/static/StaticPrivacy')
//       },
//       {
//         path: 'right',
//         name: 'StaticRight',
//         component: () => import('./views/static/StaticRight')
//       },
//       {
//         path: 'service',
//         name: 'StaticService',
//         component: () => import('./views/static/StaticService')
//       }
//     ]
//   },
//   {
//     path: '*',
//     meta: {
//       title: '找不到頁面',
//       requireAuth: true
//     },
//     component: () => import('./views/template/Layout'),
//     children: [
//       {
//         path: '',
//         name: 'NotFoundPage',
//         component: () => import('./views/error/404')
//       }
//     ]
//   }
// ]

export default new Vuex.Store({
  state: {
    token: window.localStorage.getItem('cms:token'),
    auth: false,
    userInfo: {},
    userRoutes: []
  },
  mutations: {
    setToken (state, params) {
      state.token = params.token
      Vue.axios.defaults.headers.common['Authorization'] = params.token
      window.localStorage.setItem('cms:token', params.token)
    },
    setUserInfo (state, userInfo) {
      state.userInfo = userInfo
      state.auth = true // 取得用戶訊息時，也把 auth 改為 true
      // 產生用戶權限路由
      // state.userRoutes = dynamicRoutes.filter(route => {
      //   return userInfo.menus.some(menu => menu.name === route.name)
      // })
      // state.userRoutes = dynamicRoutes
      // router.addRoutes(state.userRoutes) // 添增路由
    },
    clearLoginInfo (state) {
      state.token = ''
      delete Vue.axios.defaults.headers.common['Authorization']
      window.localStorage.removeItem('cms:token', '')
      state.userInfo = {}
      state.auth = false
      state.userRoutes = []
    }
  },
  actions: {
    login ({ commit }, user) {
      user['api_token'] = 'Ku5RMyLZcmojSA9Ioi4uM2S2jBKpJGqiV6BxDX7vNBeK80n3atguoDFWEDSS'
      return new Promise((resolve, reject) => {
        Vue.axios({ url: '/auth/login', data: user, method: 'POST' })
          .then(response => {
            if (response.data.status) {
              commit('setToken', { token: `Bearer ` + response.data.data.access_token })
              commit('setUserInfo', response.data.data)
              resolve(response)
            } else {
              commit('clearLoginInfo')
              reject(response)
            }
          })
          .catch(err => {
            commit('clearLoginInfo')
            reject(err)
          })
      })
    },
    logout ({ commit }, token) {
      return new Promise((resolve, reject) => {
        Vue.axios({ url: '/auth/logout', data: { token: token }, method: 'POST' })
          .then(resp => {
            commit('clearLoginInfo')
            resolve(resp)
          })
          .catch(err => {
            commit('clearLoginInfo')
            reject(err)
          })
      })
    },
    refreshToken ({ commit }, token) {
      commit('setToken', { token: token })
    },
    getUserInfo ({ commit }, token) {
      return new Promise((resolve, reject) => {
        Vue.axios({ url: '/auth/check', data: {}, method: 'POST' })
          .then(response => {
            if (response.data.status) {
              commit('setUserInfo', response.data.data)
              resolve(response)
            } else {
              commit('clearLoginInfo')
              reject(response)
            }
          })
          .catch(err => {
            commit('clearLoginInfo')
            reject(err)
          })
      })
    },
    clearLoginInfo ({ commit }) {
      commit('clearLoginInfo')
      window.location.reload()
    }
  }
})
